module.exports = __webpack_public_path__ + "img/ecology.f31388f5.svg";